import { PlanListModel, PlanModel } from '@/domain/models/plan-license/plan-model'

export interface Plan {
  getAll(): Promise<Plan.ListModel>
  loader(): Promise<Plan.ListModel>
}

export namespace Plan {
  export type Model = PlanModel
  export type ListModel = PlanListModel
  export const Key = 'plan-list'
}
